var map = {
	"./chatfood-icon.svg": [
		"d296",
		"icon-chatfood-icon-svg"
	],
	"./chatfood-logo-full.svg": [
		"bc90",
		"icon-chatfood-logo-full-svg"
	],
	"./chatfood-logo-new.svg": [
		"7e93",
		"icon-chatfood-logo-new-svg"
	],
	"./chatfood-name.svg": [
		"8b4e",
		"icon-chatfood-name-svg"
	],
	"./delivery-areas.svg": [
		"21a9",
		"icon-delivery-areas-svg"
	],
	"./discount-gray.svg": [
		"5e87",
		"icon-discount-gray-svg"
	],
	"./facebook.svg": [
		"81bb",
		"icon-facebook-svg"
	],
	"./google.svg": [
		"4878",
		"icon-google-svg"
	],
	"./info.svg": [
		"7f16",
		"icon-info-svg"
	],
	"./instagram.svg": [
		"02da",
		"icon-instagram-svg"
	],
	"./messenger.svg": [
		"a8c2",
		"icon-messenger-svg"
	],
	"./whatsapp.svg": [
		"4760",
		"icon-whatsapp-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "791e";
module.exports = webpackAsyncContext;